<template>
  <apollo-query v-if='!ignoreDrafts'
                :query='getPostDraftsQuery'
                client-id='localClient'
                @result='onInitialLoadDrafts'
                >
    <template v-slot="{ result: { loading, error, data }, isLoading, query }">

      <apollo-query :query='getPostDraftsQuery'
                    style='min-height: 100%'
                    client-id='localClient'
                    class="flex flex-row grow relative bg-gray-400"
                    >
        <template v-slot="{ result: { loading, error, data }, isLoading, query }">
          <div class="w-full h-full">
            <h4 class="text-sm p-2 text-gray-800">These are your drafts. They are autosaved as you edit. Choose a Draft to continue editing it.</h4>
            <div v-for='draft in sortDrafts(data.postDrafts)' :key='draft.id' class="flex flex-row w-full justify-center">
              <button @click='useDraft(draft)'
                  class='grow align-center pbc-component-link-or-transform-button mr-1'
                  :class='isCurrentClass(draft)'
                  :key='draft.id'>
                <span>{{draft.title ? draft.title : "untitled"}}</span>
                <span class="text-xs text-gray-600 my-auto ml-auto">{{formatDate(draft.updated)}}</span>
              </button>
              <apollo-mutation v-if='draft.id !== id'
                                :mutation='deletePostDraft'
                                client-id='localClient'
                                class='self-center h-full'
                                :variables='{id:draft.id}'>
                <template v-slot="{mutate}">
                  <pbc-button @click="removeDraftMutation = mutate">
                    <pencil-remove :size='32' />
                  </pbc-button>
                </template>
              </apollo-mutation>


            </div>
          </div>
        </template>
      </apollo-query>

      <pbc-confirmation v-if='removeDraftMutation'
                @cancel='removeDraftMutation = null'
                @ok='removeDraftMutation(); removeDraftMutation = null'>
        <h3 class="text-black">Do you want to remove the draft?</h3>
      </pbc-confirmation>


    </template>

  </apollo-query>

</template>
<script>
import { cloneDeep, debounce, sortBy } from 'lodash';
import PencilRemove from '@icons/PencilRemove.vue';
import { deletePostDraft, getPostDraftsQuery } from '@/gql/Queries.js';
import { addMinutes, format, formatISO9075, formatDistanceToNow } from 'date-fns'
export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      deletePostDraft,
      getPostDraftsQuery,
      removeDraftMutation: null,
      ignoreDrafts: false,
      thisHappensTwiceForSomeReason: false
    }
  },
  components: {
    PencilRemove
  },
  methods:{
    onCreateNew(close) {
      this.ignoreDrafts = true;
      close();
    },
    isCurrentClass(draft) {
      if (draft.id === this.id) {
        return 'bg-blue-200';
      } else {
        return '';
      }
    },
    async useDraft(draft, isInitial=false) {
      console.log('USE DRAFT', draft);
     this.$emit('change-draft', {
        parentId:draft.parentId,
        opId:draft.opId,
        draft
      });

      //this.showEditor = false;
      //setTimeout( () => {
        //if (!this.showPosting) {
          //this.showEditor = true;
        //}
      //}, 400);

      console.log('LOL?!?!?!');
      this.ignoreDrafts = true;

      if (isInitial) {
        this.$ana.track({
          eventCategory: 'ui',
          eventAction: 'chooseInitialDraft',
        });
      } else {
        this.$ana.track({
          eventCategory: 'ui',
          eventAction: 'chooseDraft',
        });
      }

    },
    formatDate(d) {
      return formatDistanceToNow(new Date(d));
    },
    sortDrafts(drafts) {
      const d = sortBy(drafts, 'updated');
      d.reverse();
      return d;
    },
    onInitialLoadDrafts({error,data}) {
      if (data.error || !data.postDrafts.length) {
        this.ignoreDrafts = true;
      } else {
        console.log('wtf', data);
        if (data.postDrafts.length && !this.thisHappensTwiceForSomeReason) {
          this.thisHappensTwiceForSomeReason = true;
          this.$ana.track({
            eventCategory:'ui',
            eventAction:'viewDrafts'
          });
        }
      }
    },
    doIgnoreDrafts() {
      this.ignoreDrafts = true
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'ignoreInitialDraft',
        extra:{type:'post'}
      });
    }
  }
}
</script>
